class BESSAppProjectDocsEvidence extends BESSAppBase {

    constructor() {
        super();
        this.root = $('.app-docs-evidence');
        if (this.root.length === 0) return;

        this.summary = new BESSAppProjectDocsEvidenceSidebar();
        this.documentLibrary = new BESSAppDocumentLibrary(this);
        this.supportingDocModal = new BESSAppProjectSupportingDocModal(this);
        if (this.root.length === 0) return;

        this.floorplanItems = _.map(this.root.find('.app-floorplan-item'),
            function (x) {
                return new BESSAppProjectFloorplanItem(this, $(x));
            }.bind(this));

        this.supportingDocItems = _.map(this.root.find('.app-supporting-doc-item'),
            function (x) {
                return new BESSAppProjectSupportDocItem(this, $(x));
            }.bind(this));

    }

    updateState(state) {
        this.summary.updateState(state);
        this.documentLibrary.updateState(state);
    }

    removedDocument(docId) {
        this.forEach(this.supportingDocItems, function (item) {
            item.removedDocument(docId);
        });
    }


    api() {
        return BESSApp.instance.services.api.project.docs;
    }

    updateSidebar(docs) {
        $('.app-docs-progress')
            .addClassIf('app-category-has-passed', docs.completed_credit > 0)
            .addClassIf('app-category-has-failed', !(docs.completed_credit > 0))
            .css({'width': '' + docs.progress + '%'});

        $('.app-docs-progress-text').text('' + docs.completed_credit + '/' + docs.total_credit);
    }

}
